var t;(function(e){e.white="white",e.black="black",e.default="white"})(t||(t={}));export{t as Variant};
